import React from "react";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import ErrorView from "./ErrorView";

interface IMessageEditorProps {
  show: any;
  onHide: any;
  recipient?: string;
  subject?: string;
  message?: string;
  updateSubject: any;
  updateMessageText: any;
  submitMessage: any;
  success: boolean;
  error: boolean;
}

export default class MessageEditorModal extends React.Component<IMessageEditorProps> {
  state: {
    messageBody: string;
  };

  constructor(props: IMessageEditorProps) {
    super(props);
    this.state = {
      messageBody: "",
    };
  }
  render() {
    return (
      <Modal show={this.props.show} centered onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>
            Nachricht{" "}
            {this.props.recipient === undefined && "an das KVA+-Team "}verfassen
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {this.props.error && <ErrorView />}
          {!this.props.success && !this.props.error && (
            <Form>
              {this.props.recipient && (
                <Form.Group as={Row}>
                  <Form.Label column sm={2}>
                    <strong>Empfänger:</strong>
                  </Form.Label>
                  <Form.Label column sm={10}>
                    &nbsp;
                    {this.props.recipient}
                  </Form.Label>
                </Form.Group>
              )}
              <Form.Group as={Row}>
                <Form.Label column sm={2}>
                  <strong>Betreff:</strong>
                </Form.Label>
                <Col sm={10}>
                  <Form.Control
                    placeholder="Betreff"
                    value={this.props.subject}
                    disabled={this.props.updateSubject === undefined}
                    onChange={(ev: any) =>
                      this.props.updateSubject(ev.target.value)
                    }
                  ></Form.Control>
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label>
                  <strong>Nachrichtentext</strong>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  cols={100}
                  rows={10}
                  placeholder="Ihre Nachricht..."
                  value={this.props.message}
                  onChange={(ev: any) =>
                    this.props.updateMessageText(ev.target.value)
                  }
                ></Form.Control>
              </Form.Group>
            </Form>
          )}
          {this.props.success === true && (
            <Row>
              <Col sm={2}></Col>
              <Col sm={8}>Nachricht wurde versandt!</Col>
            </Row>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.props.onHide()}>
            {this.props.success !== true && "Verwerfen"}
            {this.props.success === true && "Schließen"}
          </Button>
          {!this.props.success && !this.props.error && (
            <Button
              disabled={!this.props.message || !this.props.subject}
              onClick={() => this.props.submitMessage()}
              variant="primary"
            >
              Absenden
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}
